import { useQuery } from '@apollo/client';

import user from 'js/lib/user';

import { buildDegreeUrlAbsolute } from 'bundles/common/utils/urlUtils';
import type {
  GetAllDegreesQuery,
  GetAllDegreesQueryVariables,
  QueryCollectionFieldsForWithAllDegreesFragment,
} from 'bundles/degrees/common/__generated__/GetAllDegrees';
import getAllDegreesQuery from 'bundles/directory-graphql/api/GetAllDegrees.graphql';
import { AVAILABILITY_STATUS } from 'bundles/premium-hub/types';

type AllDegreesWithLinks = {
  allDegrees: (QueryCollectionFieldsForWithAllDegreesFragment & { link: string })[];
};

const useAllDegreesData = (): AllDegreesWithLinks => {
  const { data, ...queryResponse } = useQuery<GetAllDegreesQuery, GetAllDegreesQueryVariables>(getAllDegreesQuery, {
    variables: {
      catalogAvailabilityStatus: user.isPoweruser()
        ? [AVAILABILITY_STATUS.LIVE, AVAILABILITY_STATUS.PRE_LAUNCH]
        : [AVAILABILITY_STATUS.LIVE],
    },
    context: {
      clientName: 'gatewayGql',
    },
  });

  const catalogDegrees = data?.PremiumProductCollections?.queryCollection || [];

  const validDegrees = catalogDegrees.filter((program): program is QueryCollectionFieldsForWithAllDegreesFragment => {
    return !!program;
  });

  const allDegreesWithLink = validDegrees.map((degree) => ({
    ...degree,
    link: buildDegreeUrlAbsolute(degree.slug),
  }));

  return {
    allDegrees: allDegreesWithLink,
    ...queryResponse,
  };
};

export default useAllDegreesData;
